import { createOpQueue, type OpQueue } from './op-queue.js';
import { createOpSend } from './op-send.js';
import { createIndexedDbOpStore } from './pending-ops.js';

/**
 * The app's ONE offline queue — offline plan v1.2 §2.2 A, increments 2 and 3.
 *
 * IT WAS NAMED `photoQueue` WHEN IT ONLY CARRIED PHOTOS, and increment 3 gave it
 * movements too. The name is kept rather than churned across call sites for its own sake;
 * what it returns is a queue of OPS, and `op-send.ts` is what knows what a kind means. If
 * a third consumer arrives it is worth renaming then, in a commit that does nothing else.
 *
 * ONE queue rather than one per kind, deliberately: the concurrency limit, the retry
 * policy, the thirty-day window and the badge's count are all properties of "work this
 * device has captured and not yet handed over". Two queues would make the badge lie by
 * omission, which is the one thing §2.2 D says it must never do.
 */

let queue: OpQueue | undefined;

/**
 * Built lazily and once. Constructing it at module load would open IndexedDB during
 * import — before the boot path has decided whether storage is usable at all, and in
 * tests that never touch it.
 */
export function photoQueue(): OpQueue {
  queue ??= createOpQueue({ store: createIndexedDbOpStore(), send: createOpSend() });
  return queue;
}

/**
 * Called once from the boot path. A store that cannot be opened is REFUSED loudly by
 * `start()` rather than reported as an empty queue — the browser that silently drops
 * this is the one where a stockroom's photos vanish without a message.
 */
export async function startPhotoQueue(): Promise<void> {
  await photoQueue().start();
}
